var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatoModifica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4866",
    "data-name": "Raggruppa 4866",
    transform: "translate(-867 -378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Salva_Bozza",
    "data-name": "Salva Bozza",
    transform: "translate(-823.725 440)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INVIA_PROPO_ACQUISTO",
    "data-name": "INVIA PROPO ACQUISTO",
    transform: "translate(1690.724 -62)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_478",
    "data-name": "Rettangolo 478",
    width: 37,
    height: 37,
    rx: 3,
    fill: "#113188"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "noun-replace-6559437",
    transform: "translate(856.478 371.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9626",
    "data-name": "Tracciato 9626",
    d: "M20.878,24.136a8.06,8.06,0,0,1,5.676-7.756,7.684,7.684,0,0,1,2.15-.388v2.362a.339.339,0,0,0,.212.317c.035,0,.071.035.141.035A.469.469,0,0,0,29.3,18.6l4.054-3.984a.4.4,0,0,0,.106-.247.381.381,0,0,0-.106-.247l-.846-.846c-.035-.035-.035-.035-.071-.035l-3.173-3.1A.388.388,0,0,0,28.916,10a.308.308,0,0,0-.212.317v2.362a10.038,10.038,0,0,0-2.362.353,11.537,11.537,0,0,0-8.743,11.1,11.32,11.32,0,0,0,4.477,9.025c.035.035.141.035.176.035a.523.523,0,0,0,.247.035,1.989,1.989,0,0,0,1.445-.494,2.276,2.276,0,0,0,.529-1.692.884.884,0,0,0-.141-.247A8.286,8.286,0,0,1,20.878,24.136Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9627",
    "data-name": "Tracciato 9627",
    d: "M48.816,24.262c-.035-.035-.106-.035-.141-.071a2.268,2.268,0,0,0-1.692.494,2.239,2.239,0,0,0-.529,1.657c.035.106.071.212.141.247a8.286,8.286,0,0,1,3.455,6.663,8.072,8.072,0,0,1-5.64,7.756,6.6,6.6,0,0,1-2.186.353V39.033a.37.37,0,0,0-.176-.317.41.41,0,0,0-.353.071l-4.089,4.054a.4.4,0,0,0-.106.247.469.469,0,0,0,.106.247l.846.846c.035.035.035.035.071.035l3.137,3.1a.509.509,0,0,0,.247.071h.141a.33.33,0,0,0,.176-.317V44.709a9.766,9.766,0,0,0,2.362-.353,11.427,11.427,0,0,0,8.743-11.069A11.155,11.155,0,0,0,48.816,24.262Z",
    transform: "translate(-12.885 -9.186)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatoModifica);
export default __webpack_public_path__ + "static/media/StatoModifica.0c5cf6b1d04023fe1bc350761b234a29.svg";
export { ForwardRef as ReactComponent };